@if (filter(); as filter) {
  @if (control(); as control) {
    @switch (filter.uiType) {
      @case ("Checkbox") {
        @if (isFormRecord(control)) {
          <procure-search-filter-checkbox
            [label]="filter.name"
            [control]="control"
            [options]="filter.values"
          />
        }
      }
      @case ("Dropdown") {
        @if (isFormControl(control)) {
          <procure-search-filter-select
            [label]="filter.name"
            [control]="control"
            [options]="filter.values"
            [multiple]="false"
          />
        }
      }
      @case ("MultiSelectDropdown") {
        @if (isFormControl(control)) {
          <procure-search-filter-select
            [label]="filter.name"
            [control]="control"
            [options]="filter.values"
            [multiple]="true"
          />
        }
      }
      @case ("NumberRange") {
        @if (isFormGroup(control)) {
          <procure-search-filter-range
            [label]="filter.name"
            [control]="control"
            [options]="filter.values"
          />
        }
      }
    }
  }
}
